import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EdpService } from '../services/edp.service'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  usuario: string = '';
  passw: string = '';
  showPwd: boolean = false;

  constructor(public service: EdpService, private router:Router) { }

  ngOnInit(): void {
  }

  login() {
    if(!this.usuario) alert('Ingresa un nombre de usuario')
    else if(!this.passw) alert('Ingresa una contraseña')
    else{
      this.service.login(this.usuario, this.passw).subscribe(data => {
        if(data.includes('Error:')){
          alert(data.split('Error: ')[1])
        }else if(data){
          const actual = Date.now() // Fecha actual en milisegundos
          const actualAdj = actual + 86400000 // 1000 * 60 * 60 * 24 // Milisegundos * Segundos * Minutos * Horas // Agregar un dia a fecha actual
          // console.log(actualAdj + data + this.usuario)
          sessionStorage.setItem('edpp-token', this.service.cambiarPalabra(actualAdj + data + this.usuario))
          localStorage.removeItem('edpp-periodo')
          this.router.navigate(['/'])
        }
        else{
          alert('Error desconocido: Vuelve a intentarlo más tarde.')
        }
      }, err => {
        if(!err.ok) alert('Error del servidor: Vuelve a intentarlo más tarde.')
      })
    }
  }

  mostrarPwd() {
    this.showPwd = !this.showPwd;
  }
}
